export const generateUserImageUrl = (userEmail: string, size: 'L' | 'M' | 'S') => {
  const baseUrl = 'https://img.morganlewis.net/p';
  let fileName: string;
  if (size === 'L') {
    fileName = 'full.jpg';
  } else {
    fileName = size === 'M' ? 'medium.jpg' : 'tb.jpg';
  }
  return `${baseUrl}/${userEmail}/${fileName}`;
};
